//User
import Profile from "./views/Profile";
import AjouterUser from "./views/Settings/User/AjouterUser";
import ListUser from "./views/Settings/User/ListUser";

//Role
import ListRole from "./views/Settings/Role/ListRole";
import AjouterRole from "./views/Settings/Role/AjouterRole";

//Type
import ListType from "./views/Settings/Type/ListType";
import AjouterType from "./views/Settings/Type/AjouterType";

//Status
import ListStatus from "./views/Settings/Status/ListStatus";
import AjouterStatus from "./views/Settings/Status/AjouterStatus";


//Reglement
import ListReglement from "./views/Reglement/ListReglement";

//Livraison 
import ListLivraison from "./views/Livraison/ListLivraison";
import DetailsLivraison from "./views/Livraison/DetailsLivraison";

//Facture
import ListFacture from "./views/Facture/ListFacture";
import DetailsFacture from "./views/Facture/DetailsFacture";

import NotFound from "./views/NotFound";
import Settings from "./views/Settings";

//RootBase
import ListRootBase from "./views/Settings/RootBase/ListRootBase";
import AjouterRootBase from "./views/Settings/RootBase/AjouterRootBase";

//Annee
import ListAnnee from "./views/Settings/Annee/ListAnnee";
import AjouterAnnee from "./views/Settings/Annee/AjouterAnnee";

//Actualité
import ListActualite from "./views/Settings/Actualite/ListActualite";
import AjouterActualite from "./views/Settings/Actualite/AjouterActualite";
              
import ListNew from "./views/Settings/New/ListNew";
import AjouterNew from "./views/Settings/New/AjouterNew";

//Carousel
import ListCarousel from "./views/Settings/Carousel/ListCarousel";
import AjouterCarousel from "./views/Settings/Carousel/AjouterCarousel";

//Produit
import ListProduit from "./views/Settings/Produit/ListProduit";
import AjouterProduit from "./views/Settings/Produit/AjouterProduit";
import ListProduitFour from "./views/Settings/Produit/ListProduitFour";
import ListProduitFourV from "./views/Settings/Produit/ListProduitFourV";

//Grossiste
import ListGrossiste from "./views/Settings/Grossiste/ListGrossiste";
import AjouterGrossiste from "./views/Settings/Grossiste/AjouterGrossiste";

//Reclamation
import ListReclamation from "./views/Reclamation/ListReclamation";
import AjouterReclamation from "./views/Reclamation/AjouterReclamation";
import DetailsReclamation from "./views/Reclamation/DetailsReclamation";
import DetailsAvoirRetour from "./views/Reclamation/DetailsAvoirRetour";
import DetailsReclamationAll from "./views/Reclamation/DetailsReclamationAll";


//Commande
import ListCommande from "./views/Commande/ListCommande";
import DetailsCmd from "./views/Commande/DetailsCmd";
import DetailsCmdRef from "./views/Commande/DetailsCmdRef";
import AddCommande from "./views/Commande/AddCommande";
import AddCommandeExcel from "./views/Commande/AddCommandeExcel";
import MenuCmd from "./views/Commande/MenuCmd";
import AddCommandeParProduit from "./views/Commande/AddCommandeParProduit";
import AddCommandeListProduit from "./views/Commande/AddCommandeListProduit";
import UpdateCmd from "./views/Commande/UpdateCmd";
import ListCommandeValider from "./views/Commande/ListCommandeValider";
import MesActualite from "./views/Settings/Actualite/MesActualite";
import DetailsActualite from "./views/Settings/Actualite/DetailsActualite";
import ListReclamationValider from "./views/Reclamation/ListReclamationValider";

//Messagerie
import Messagerie from "./views/Messagerie/Messagerie";
import Deconnexion from "./views/Deconnexion";

//PCT
import extraction_PCT from "./views/PCT/pct";
import list_PCT from "./views/PCT/ListPCT"


//Ims
import AjouterIms from "./views/Settings/Ims/AjouterIms";
import ListIms from "./views/Settings/Ims/ListIms";


//ims


//Activite
import AjouterActivite from "./views/Settings/Activite/AjouterActivite";
import ListActivite from "./views/Settings/Activite/ListActivite";


//LigneIms
import AjouterLigneIms from "./views/Settings/LigneIms/AjouterLigneIms";
import ListLigneIms from "./views/Settings/LigneIms/ListLigneIms";

//MarcheIms
import ListMarcheIms from "./views/Settings/MarcheIms/ListMarcheIms";
import AjouterMarcheIms from "./views/Settings/MarcheIms/AjouterMarcheIms";


//PP
import extraction_PP from "./views/Settings/PrixProduit/extraction_PP";
import list_PP from "./views/Settings/PrixProduit/list_PP";
import DetailPP from "./views/Settings/PrixProduit/DetailPP";
import DashBoard from "./views/DashBoard.js";

import ListeReleveInserer from "./views/Releve/ListeReleveInserer.js";
import TelechargerFichierReleveInserer from "./views/Releve/TelechargerFichierReleveInserer.js";
import ReleveInserer from "./views/Releve/ReleveInserer.js";
import Main from "./Main.js";
import ListReporting from "./views/Settings/Reporting/ListReporting.js";
import AjouterReporting from "./views/Settings/Reporting/AjouterReporting.js";

//imsNat
import extraction_ImsNat from "./views/ImsNat/extraction_ImsNat.js";
import list_ImsNat from "./views/ImsNat/list_ImsNat.js";
import DetailImsNat from "./views/ImsNat/DetailImsNat.js";
import ListeRapport from "./views/RapportC.js";



//SuivieBl
import extraction_SuivieBl from "./views/SuiviBl/extraction_SuivieBl.js";
import list_SuivieBl from "./views/SuiviBl/list_SuivieBl.js";
import DetailSuivieBl from "./views/SuiviBl/DetailSuivieBl.js";

//simulation
import extraction_Simulation from "./views/SimulationCommande/extraction_simulation.js";
import list_Simulation from "./views/SimulationCommande/list_Simulation.js";
import DetailSimulation from "./views/SimulationCommande/DetailSimulation.js";

//simulation commerciale
import SimulationC from "./views/SimulationC/ListSimulationC.js";
import UpdateSimulationC from "./views/SimulationC/UpdateSimulationC.js";
import AjouterSimulationC from "./views/SimulationC/AjouterSimulationC.js";
import DetailSimulationC from "./views/SimulationC/DetailSimulationC.js";
import DetailSimulationCGro from "./views/SimulationCGro/DetailSimulationCGro.js";
import ModifierReclamationAll from "./views/Reclamation/ModifierReclamationAll.js";
import ListReclamationRetourValider from "./views/Reclamation/ListReclamationRetourValider.js";
import ListCalendrierLivraison from "./views/CalendrierLivraison/ListCalendrierLivraison.js";
import DetailsLivraisonProforma from "./views/CalendrierLivraison/DetailsLivraisonProforma.js";
import ListSimulationCGro from "./views/SimulationCGro/ListSimulationCGro.js";



import DetailsLivraisonCalend from "./views/CalendrierLivraison/DetailsLivraisonCalend.js";

//budget
import DetailBudget from "./views/Budget/DetailBudget.js";
import list_Budget from "./views/Budget/list_Budget.js";
import extraction_Budget from "./views/Budget/extraction_Budget..js";


//livraison magasin 
// import ListLivraisonMagasin from "./views/LivraisonMagasin/ListLivraisonMagasin.js";
// import DetailsLivraisonMagasin from "./views/LivraisonMagasin/DetailsLivraisonMagasin.js";
// import DetailsLivraisonMagasinEnvoie from "./views/LivraisonMagasin/DetailsLivraisonMagasinEnvoie.js";


//commande

import DetailsAvoirReclamation from "./views/Reclamation/DetailsAvoirReclamation.js";

//proforma
import AjouterProforma from "./views/Proforma/AjouterProforma.js";
import ListProforma from "./views/Proforma/ListProforma.js";
import DetailsProforma from "./views/Proforma/DetailsProforma.js";

//import facture
import ListImportFacture from "./views/ImportFacture/ListImportFacture.js";
import AjouterImportFacture from "./views/ImportFacture/AjouterImportFacture.js";
import DetailsImportFacture from "./views/ImportFacture/DetailsImportFacture.js";
import AjouterProduitParent from "./views/Settings/Produit/AjouterProduitParent.js";
import DetailsCmdSage from "./views/Commande/DetailsCmdSage.js";



const Components = {
  DetailsCmdSage,
  DetailsProforma,
  ListSimulationCGro,
  AjouterProduitParent,
  DetailsImportFacture,
  AjouterImportFacture,
  ListImportFacture,
  UpdateSimulationC,
  DetailsLivraisonProforma,
  DetailsLivraisonCalend,
  ListProforma,
  AjouterProforma,
  DetailsAvoirReclamation,
  DetailSimulation,
  extraction_Budget,
  list_Budget,
  DetailBudget,
  ListCalendrierLivraison,
  ListReclamationRetourValider,
  ModifierReclamationAll,
  DetailSimulationCGro,
  list_Simulation,
  AjouterSimulationC,
  DetailSimulationC,
  SimulationC,
  extraction_Simulation,
  extraction_SuivieBl,
  list_SuivieBl,
  DetailSuivieBl,
  ListeRapport,
  extraction_ImsNat,
  list_ImsNat,
  DetailImsNat,
  ListReporting,
  AjouterReporting,
  ListActivite,
  AjouterActivite,
  extraction_PP,
  ListeReleveInserer,
  Main,
  TelechargerFichierReleveInserer,
  ReleveInserer,
  DashBoard,
  AjouterIms,
  ListIms,
  AjouterLigneIms,
  ListLigneIms,
  ListMarcheIms,
  AjouterMarcheIms,
  DetailPP,
  list_PP,
  // extraction_PP,
  list_PCT,
  extraction_PCT,
  Deconnexion,
  ListUser,
  AjouterUser,
  Profile,
  ListRole,
  AjouterRole,
  NotFound,
  Settings,
  ListRootBase,
  AjouterRootBase,
  AjouterAnnee,
  ListAnnee,
  ListActualite,
  MesActualite,
  AjouterActualite,
  AjouterNew,
  ListNew,
  AjouterCarousel,
  ListCarousel,
  ListProduit,
  AjouterProduit,
  ListGrossiste,
  AjouterGrossiste,
  ListCommande,
  DetailsCmd,
  UpdateCmd,
  AddCommande,
  AddCommandeExcel,
  MenuCmd,
  ListProduitFour,
  ListProduitFourV,
  AddCommandeParProduit,
  AddCommandeListProduit,
  ListCommandeValider,
  DetailsActualite,
  ListType,
  AjouterType,
  ListStatus,
  AjouterStatus,
  ListReclamation,
  AjouterReclamation,
  DetailsReclamation,
  ListReclamationValider,
  DetailsReclamationAll,
  Messagerie,
  DetailsLivraison,
  ListLivraison,
  DetailsFacture,
  ListFacture,
  ListReglement,
  DetailsCmdRef,
  DetailsAvoirRetour
};
export default Components;
